import ScrollReveal from "../../../components/feature/ScrollReveal";
import { useYokohamaData } from "../../../lib/useMockData";

export default function RecommendTime() {
  const { recommendByTime } = useYokohamaData();
  return (
    <section className="py-20 md:py-28 bg-airdoa-navy text-white">
      <div className="px-4 md:px-8 lg:px-12">
        <div className="max-w-5xl mx-auto">
          <ScrollReveal direction="up">
            <div className="text-center mb-12 md:mb-14">
              <p className="text-xs font-medium tracking-ultra text-airdoa-gold uppercase mb-3">
                {recommendByTime.label}
              </p>
              <h2 className="text-2xl md:text-3xl lg:text-4xl font-serif font-semibold leading-tight">
                {recommendByTime.title}
              </h2>
              <p className="mt-3 text-sm text-white/60 max-w-2xl mx-auto leading-relaxed">
                {recommendByTime.subtitle}
              </p>
            </div>
          </ScrollReveal>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
            {recommendByTime.items.map((item, idx) => (
              <ScrollReveal key={item.time} direction="up" delay={idx * 100}>
                <div className="p-6 bg-airdoa-navy-light rounded-lg border border-white/10 h-full">
                  <span className="inline-block px-2.5 py-1 text-[10px] font-medium text-airdoa-gold bg-airdoa-navy rounded mb-3 border border-airdoa-gold/30">
                    {item.tag}
                  </span>
                  <p className="text-lg font-serif font-semibold text-airdoa-gold">{item.time}</p>
                  <p className="mt-1.5 text-sm text-white/80 leading-[1.8]">{item.for}</p>
                  <div className="mt-4 pt-4 border-t border-white/10">
                    <p className="text-xs text-white/50 mb-1">おすすめシーン</p>
                    <p className="text-sm text-white/90">{item.scene}</p>
                  </div>
                  <div className="mt-3 pt-3 border-t border-white/10">
                    <p className="text-xs text-white/50 mb-1">なぜおすすめ？</p>
                    <p className="text-sm text-white/80 leading-[1.8]">{item.why}</p>
                  </div>
                </div>
              </ScrollReveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
